import type { VirtualItem, Virtualizer } from '@tanstack/react-virtual';
import React from 'react';

import { Highlighter, TableCell, TableRow } from '@ifs-gcp/components';
import type { ChecklistChapterChild } from '@ifs-gcp/core/models';

import { getTranslation } from '@/utils/translations';

import type { BaseFilterableTableColumn } from '../../utils';

type ChapterRowProps = {
  virtualItem: VirtualItem;
  rowVirtualizer: Virtualizer<HTMLDivElement, Element>;
  visibleColumns: Record<string, BaseFilterableTableColumn>;
  language: string;
  searchText: string;
  activeColumnIds: string[];
  row: ChecklistChapterChild;
};

export const ChapterRow = ({
  virtualItem,
  rowVirtualizer,
  visibleColumns,
  language,
  searchText,
  activeColumnIds,
  row,
}: ChapterRowProps) => {
  const content = [
    {
      key: 'requirementNo',
      element: (
        <TableCell
          size="small"
          weight="bold"
          width={visibleColumns.requirementNo.width}
          minWidth={visibleColumns.requirementNo.minWidth}
        >
          <Highlighter search={searchText} content={row.chapterNumber} />
        </TableCell>
      ),
    },
    {
      key: 'requirementText',
      element: (
        <TableCell
          size="small"
          weight="bold"
          width={visibleColumns.requirementText.width}
          minWidth={visibleColumns.requirementText.minWidth}
        >
          <Highlighter search={searchText} content={getTranslation(row.headerText, language)} />
        </TableCell>
      ),
    },
  ];

  const filteredColumns = content.filter(({ key }) => activeColumnIds.includes(key));

  return (
    <TableRow
      isGray
      data-index={virtualItem.index}
      ref={rowVirtualizer.measureElement}
      style={{
        transform: `translateY(${virtualItem.start}px)`,
      }}
    >
      {filteredColumns.map(({ key, element }) => {
        return <React.Fragment key={key}>{element}</React.Fragment>;
      })}
    </TableRow>
  );
};
